import { StatsigUser } from '@statsig/js-client';

import { USER_ATTRIBUTES_IDENTIFIER } from '../../constants/tagManager';
import { ICompanyData, IUserCompany, IUserHolding } from '../../interfaces/businessData';
import { ICompanyPlan } from '../../interfaces/plans';
import { getUserProps } from '../gtm/tagManager';

export interface IStatsigUserParams {
  userId: string;
  email?: string;
  holdingList: IUserHolding[];
  company: IUserCompany;
  companyData: ICompanyData;
  plans: ICompanyPlan[];
  planType: string;
}

export const buildStatsigUser = ({
  userId,
  email,
  holdingList,
  company,
  companyData,
  plans,
  planType
}: IStatsigUserParams): StatsigUser => {
  const { companiesRolesList, companiesIdList, externalIdList } = getUserProps(holdingList);

  return {
    userID: USER_ATTRIBUTES_IDENTIFIER.concat(userId),
    custom: {
      adminCompaniesIds: companiesIdList,
      adminRoles: companiesRolesList,
      adminCompaniesClientIds: externalIdList,
      selectedCompanyClientId: company.externalId ?? '',
      selectedCompanyPlanIds: plans.map((plan) => plan.id.toString()),
      selectedCompanyCountryCode: companyData.countryCode,
      selectedCompanyCreatedAt: companyData.createdAt,
      selectedCompanyPlanType: planType
    },
    privateAttributes: {
      email
    }
  };
};
